export default {
  SignOut: 'Sign out',
  CareFor: 'Care for #{clientName}',
  Tree: {
    Dashboard: {
      Title: 'Care Plan',
      Options: {
      },
    },
    Profile: {
      Title: 'Profile',
      Options: {
      },
    },
    Schedule: {
      Title: 'Schedule',
      Options: {
      },
    },
    Caregivers: {
      Title: 'Caregivers',
      Options: {
      },
    },
  },
};
